/**
 * breakpoints — the device targets the canvas can author for. The ladder is
 * three (desktop → tablet → mobile); the type + widths live here so the
 * switcher, the page width, the device chrome, and the per-breakpoint layout
 * overrides all agree. Kept deliberately small and data-only (no React) so both
 * web and native can import it.
 *
 * Desktop is fluid — capped at DESKTOP_MAX_WIDTH but shrinking to the editor
 * viewport (see useAuthoringWidth). Tablet and mobile are fixed device widths
 * (the iPad / iPhone logical widths), so authoring at those mirrors a real
 * tablet / phone viewport.
 */
export type Breakpoint = "desktop" | "tablet" | "mobile";

export const DESKTOP_MAX_WIDTH = 1440;
export const TABLET_WIDTH = 768;
export const MOBILE_WIDTH = 390;

/** The authoring width for a breakpoint. Desktop passes through the (capped)
 *  viewport width; tablet and mobile are fixed device widths. */
export function breakpointWidth(bp: Breakpoint, viewportWidth: number): number {
  if (bp === "mobile") return MOBILE_WIDTH;
  if (bp === "tablet") return TABLET_WIDTH;
  return Math.min(viewportWidth, DESKTOP_MAX_WIDTH);
}
